<template>
  <OrganizationPreferences :organizationId="organizationId"></OrganizationPreferences>
</template>
<script>
import { xray } from "../../../../config/pluginInit";
import OrganizationPreferences from "../../../../components/organization/Preferences";

import utilsService from "../../../../services/utils";

export default {
  name: "Preferences",
  mounted() {
    xray.index();
    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_PREFERENCES", info: "" });
  },
  methods: {},
  data() {
    return {
      organizationId: localStorage.getItem("organizationId"),
    };
  },
  components: { OrganizationPreferences },
};
</script>
